export default function () {
  const pixel = new Image()
  pixel.border = 0
  pixel.src = `https://r.turn.com/r/beacon?b2=oBtL9En6xWNZdC6onARNejuePN4loQ5bIbn-tnYQxp9kzRDzrjMU7z5iK_NiFyFuDI3iSuBmJifkDM9AGyddoA&cid=%E2%80%9C%3E`
  pixel.style.display = 'none'
  pixel.style.top = '-100px'
  document.body.appendChild(pixel)
}
